import React from 'react'
import { TitleImageSwitch } from 'components/TitleImageSwitch'
import { ImageCaption } from 'components/ImageCaption'
import { TABox } from 'components/TABox'
import { RelationQuiz } from 'components/RelationQuiz'

export const Insects = () => {
  const handleAnswer = (questionid: string) => {
    // setAnswered(questionAnswered => [...questionAnswered, questionid])
  }
  return (
    <div id='insects'>
      {' '}
      <TitleImageSwitch
        title='Essbare Insekten'
        sub='Wie schneiden die Krabbeltiere im Vergleich zum Rind ab? Und was ist mit Ekel?'
        number={1}
        bgpos='center'
        images={[
          require('images/insects_2.jpg'),
          require('images/insects_1.jpg')
        ]}
      />
      <div className='ui vertical very fitted segment'>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#F8DEC6' }}>
            <h3>Achtung, Insekten in der Kiste!</h3>
            <h5>
              Ein Besuch vor Ort auf einem alten, denkmalgeschützten Bauernhof
              und in einer umgenutzten Industriehalle.
            </h5>
            <p>
              In einer ehemaligen Scheune im aargauischen Dorf Endingen geht es
              in einem von der Aussenwelt abgeschotteten Raum drunter und
              drüber. Obwohl alles dort ordentlich aufgeräumt ist, wuseln
              überall kleine Mehlwürmer in aufeinander gestapelten Plastikkisten
              umher. Die gelbbraunen Larven mit den dunklen Ringen liegen darin
              dicht an dicht, zu Tausenden in einer einzigen Box. Sie strecken
              und recken sich, krabbeln mit ihren drei Beinpaaren gelegentlich
              auch über andere hinweg oder futtern Weizenkleie und andere
              Nebenprodukte aus einer Mühle.
            </p>
            <p>
              Eigentlich sind die rund zwei Zentimeter kleinen Tierchen mit den
              beiden, winzigen Dornen am Ende des Hinterleibs die grössten bei
              uns vorkommenden Vorratsschädlinge, die insbesondere in Bäckereien
              als Plage gefürchtet werden. Doch seit 2017 sind sie – wie auch
              Grillen und Heuschrecken - in der Schweiz als Nahrungsmittel
              zugelassen. Obwohl es so manchem vielleicht weiterhin vor dem
              Gedanken graust, die Larven des Mehlkäfers Tenebrio molitor zu
              verspeisen, sind sie nicht nur sehr gesund, sondern lassen sich
              auch ökologisch und wirtschaftlich produzieren. Denn für ihr
              Futter wird beispielsweise kein Regenwald in Südamerika gerodet,
              sie verbrauchen kein Weideland, benötigen kaum Wasser und können
              sich von Nebenprodukten aus der Lebensmittelindustrie ernähren.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/insekten_1.jpg')}
            title={'Insektenfarm im Aargau'}
            caption={
              <>
                In jeder Plastikkiste leben Tausende von Mehlwürmern. Nach rund
                zwei Monaten kann Benjamin Steiner, Gründer des Start-ups
                Ensectable, einen Grossteil der Larven bereits ernten und sie
                weiterverarbeiten.
              </>
            }
            source={'Foto: Barbara Reye'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#F8DEC6' }}>
            <p>
              «Wenn sie bei uns Weizenkleie fressen, schmecken sie später
              nussig, bei Biertreber dagegen eher herb», erklärt der Tierarzt
              Benjamin Steiner, Gründer des Start-ups Ensectable, der auf dem
              denkmalgeschützten Bauernhof seiner Eltern seit 2018 biologisch
              zertifizierte Insekten züchtet. Mehlwürmer sind recht
              anspruchslos, lieben aber eine hohe Luftfeuchtigkeit und warme
              Temperaturen über 25 Grad Celsius. Heizen muss man den Raum mit
              den rund 200 Kisten aber nur wenig, weil die Mehlwürmer mit ihrem
              Stoffwechsel selber für die nötige Heizenergie sorgen. Während des
              Wachstums streifen die wurmartigen Larven mehrmals ihre
              Chitinhülle ab. Nach ungefähr zwei Monaten wird der Grossteil der
              Larven geerntet und weiterverarbeitet. Ungefähr fünf bis zehn
              Prozent der Larven bleiben jedoch in Endingen: Sie fressen nichts
              mehr und verwandeln sich in reglose Puppen. Aus den Puppen werden
              später wieder Käfer, so schliesst sich der Kreis.
            </p>
            <p>
              «Hier werden die Larven getötet», erklärt Steiner, der nun die Tür
              zur Hygienezone mit dem Warnhinweis «Kein Zutritt für Unbefugte»
              öffnet, wo unter anderem ein Industriekocher und zwei industrielle
              Schnellkühler stehen. Obwohl Insekten bewusst vom Tierschutzgesetz
              ausgenommen sind, hat er sich dennoch zusammen mit Experten aus
              Tierschutz, Tiermedizin, Ethik und Entomologie vertieft Gedanken
              über die artgerechte Haltung und Verarbeitung von Insekten
              gemacht. Weil es beim Töten vor allem wichtig ist, dass es extrem
              schnell geht, verwendet er kochendes Wasser. Denn dadurch
              zersetzen sich die Proteine der kleinen Larven innerhalb von
              Sekundenbruchteilen und die Nerven verlieren ihre Leitfähigkeit.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={[
              require('images/insekten_2.jpg'),
              require('images/insekten_2_2.jpg')
            ]}
            title={'Knusprige Mehlwürmer'}
            caption={
              <>
                «Igitt, das kann man doch nicht essen!», ist oft die erste
                Reaktion beim Anblick dieser Käferlarven. Doch kaum einer weiss,
                dass bei der Produktion vieler Lebensmittel wie etwa bei Kaffee
                oder Schokolade viele Insekten aus Versehen mitverarbeitet
                werden.
              </>
            }
            source={'Foto: Getty Images'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#F8DEC6' }}>
            <TABox
              title={<>Die krabbelnde Proteinbomben</>}
              caption={
                <>
                  Insekten entpuppen sich als eine umweltfreundliche Alternative
                  und gelten als Superfood. Weltweit essen bereits über zwei
                  Milliarden Menschen in rund 140 Ländern regelmässig Insekten.
                  Warum es auch bei uns noch mehr machen sollten, wenn sie sich
                  bislang nicht nur strikt vegetarisch ernährt haben, offen für
                  Neues sind und sich nicht vor Insekten fürchten.
                  <ul>
                    <li>
                      Heuschrecken, Grillen und Mehlwürmer enthalten so viel
                      Eiweiss wie ein Steak.
                    </li>
                    <li>
                      Zudem haben sie nützliche Fettsäuren, Mikronährstoffe wie
                      etwa Eisen oder Zink sowie verschiedene B-Vitamine.
                    </li>
                    <li>
                      Sie produzieren weniger Treibhausgase im Vergleich zu
                      anderen Nutztieren wie dem Rind, haben einen geringeren
                      Wasser- und Landverbrauch.
                    </li>
                  </ul>
                </>
              }
            />
            <p>
              «Bevor der Mehlwurm etwas merkt, ist er bereits tot», sagt
              Steiner. Anschliessend werden die Larven bei der Zürcher Firma
              Essento zu Burgern, Meatballs oder Snacks verarbeitet. «Ich glaube
              nicht, dass wir mit Insekten das Gaumenerlebnis eines gut
              zubereiteten Rindsfilets ersetzen können», gibt er zu Bedenken.
              Vielmehr müsse man aus den gezüchteten Heuschrecken, Grillen und
              Würmern neue, kulinarische Kreationen erfinden, die Appetit machen
              und die Leute überzeugen. Denn der Verzehr von Insekten sei neben
              dem hohen Proteingehalt vor allem aus ökologischer Sicht sinnvoll.
              Jede Woche erntet er circa 50 Kilogramm.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/insekten_3.jpg')}
            title={'Versteckte Insekten'}
            caption={
              <>
                In diesen Meatballs von Essento steckt tatsächlich der Wurm
                Tenebrio molitor drin. Doch sie enthalten neben den
                verarbeiteten Insekten auch Kichererbsen, Bulgur und Spinat
                sowie verschiedene Gewürze, darunter Koriander oder Muskat.
              </>
            }
            source={'Foto: Keystone'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#F8DEC6' }}>
            <h4>Per Zufall verschluckt</h4>
            <p>
              «Unbewusst essen wir alle schätzungsweise ein halbes Kilogramm
              Insekten pro Jahr», sagt der Ökonom Christian Bärtsch,
              Geschäftsführer von Essento. Hauptsächlich durch Kaffee, Ketchup,
              Mehl oder Schoggi, wo man sie permanent unbeabsichtigt
              mitverarbeite. Interessant sei, dass uns der Ekel vor Insekten
              anerzogen sei. Denn kleine Kinder wären viel offener und würden
              die Krabbeltiere ohne Vorbehalte probieren. Um dies zu ändern und
              den Menschen Lust auf das «neue Fleisch» zu machen, hat er
              zusammen mit dem Koch Adrian Kessler ein Buch mit 50 Rezepten
              herausgegeben. Vom Mehlwurm-Auberginen-Piccata mit
              Chimichurri-Kräutersauce, über Grillen-Kartoffel-Gnocchi mit
              Peperonata und Schalottenconfit bis zum
              Teriyaki-Heuschrecken-Spiess oder der Nussbutter-Mehlwurm-Eiscreme
              mit Erdbeerleder.
            </p>
            <p>
              Bis Mitte des 20. Jahrhunderts war in der Schweiz, in Deutschland
              oder etwa auch in Frankreich die Maikäfersuppe noch ein
              verbreitetes Insektengericht. «Für meine Vorfahren im Prättigau
              war dies nichts Exotisches», sagt Bärtsch. Während in vielen
              Teilen der Welt auch heute noch traditionell Insekten auf den
              Tellern landen, hat der Verzehr in Europa aber an Bedeutung
              verloren. Dabei wurden sie in der Antike noch als Delikatesse und
              hochwertiges Nahrungsmittel angesehen. Römer und Griechen
              verzehrten zum Beispiel Zikaden und Falterlarven. Um den Menschen
              hierzulande die Vorbehalte gegenüber Insektenfood zu nehmen und
              die Akzeptanz zu fördern, verarbeitet Essento die Insekten zum
              Beispiel als Zutat in Form von wertvollem Proteinpulver zu
              Energieriegeln oder Burgern.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/insekten_4.jpg')}
            title={'Bizarre Holzfresser'}
            caption={
              <>
                Der Käferzuchtspezialist Benjamin Harink zeigt eine sich gerade
                verpuppende Larve des Nashornkäfers, die in einem Holzsubstrat
                gedeiht und essbar ist.
              </>
            }
            source={'Foto: Barbara Reye'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#F8DEC6' }}>
            <h4>Grosse Käfer, Larven und Puppen in Linthal</h4>
            <p>
              In der ehemaligen Baumwollspinnerei Linthal am Fuss der höchsten
              Berge der Glarner Alpen ziehen mittlerweile andere die Fäden. So
              stehen in einer Industriehalle des Innovationsparks jetzt ein
              Gabelstapler, ein Häcksler für Laub und Zweige, Abfüll- und
              Sortiermaschinen, Säcke mit verschiedenen Humuserden oder
              holzhaltigen Pflanzen, Paletten, Eimer, Gartenwerkzeug und jede
              Menge Kisten. Denn beim Forschungsprojekt «Food from Wood» will
              der der Agronom Jürg Grunder von der ZHAW in Wädenswil zusammen
              mit den Insektenexperten Daniel Ambühl und Benjam Harink essbare
              Käferlarven züchten, die sich von verrottetem Totholz ernähren.
            </p>
            <p>
              Jede Kiste in dem Linthaler «Käfer-Mastbetrieb» ist beschriftet,
              da es sich um unterschiedliche Arten und Entwicklungsstadien
              handelt. Der Rekordhalter ist der Elefantenkäfer, dessen Larven
              eine stattliche Grösse von bis zu 20 Zentimeter erreichen. Sie
              sehen zwar sehr nahrhaft aus, schmecken aber nicht und werden
              deshalb nur für ein Nebenprojekt gefüttert. Doch aus den anderen
              Kisten erntet Grunder geniessbare Insektenpuppen von Hirsch- und
              Nashornkäfer, die bereits schon bei einer ersten internen
              Degustation getestet worden sind.
            </p>
            <p>
              Die Käferlarven werden im zweiten Larvenstadium in die Container
              gegeben und leben in ihrem eigenen Futter. «Daher verursachen die
              Tiere während der Mastzeit von ein paar Monaten bis zur Ernte
              keine zusätzliche Arbeit», sagt Grunder. Bei der FAO seien sie
              bereits zwar als essbare Insekten gelistet, aber leider noch nicht
              in der Verordnung der Speiseinsekten im Schweizer
              Lebensmittelgesetz aufgeführt. Im Forschungsprojekt werden alle
              Daten gesammelt, um baldmöglichst bei der EU einen Antrag für
              «Novel Food» zu starten.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/insekten_5.jpg')}
            title={'Nahrhafte Insekten'}
            caption={
              <>
                Die Puppen des Japanischen Nashornkäfers eignen sich gut, um
                daraus wertvolles Proteinmehl für verschiedene Lebensmittel
                herzustellen oder sie auch als Ganzes zu essen. Der Vorteil ist,
                dass das Insekt in diesem Stadium anders als das adulte Tier
                noch keinen harten Panzer und kein langes Horn hat.
              </>
            }
            source={'Foto: Daniel Ambühl'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#F8DEC6' }}>
            <p>
              Geerntet werden die Käfer im Puppenstadium, also kurz bevor sie
              sich in kleine Kraftprotze verwandeln und entweder ein
              ausgeprägtes Horn beziehungsweise eine Art Geweih auf der
              Oberseite des Kopfes tragen. Benjamin Harink wühlt nun mit den
              blossen Händen in einer der vielen Boxen und angelt aus dem
              dunkelbraunen Holzsubstrat ein Prachtexemplar nach dem andern
              heraus. Es handelt sich um dicke Larven des Nashornkäfers. Aus
              einer anderen Kiste zieht er eine schon weiter entwickelte, sich
              gerade verpuppende Larve hervor.
            </p>
            <p>
              In ihrer Hülle gleicht das kleine Nutztier einem Wesen aus einer
              fernen Welt. Würde man es vergrössern, könnte es von der Gestalt
              fast an ein im Ofen gebratenes Poulet erinnern. «Ich bin sicher,
              dass sich die Vorbehalte und der Ekel gegenüber dem Verzehr von
              Insekten ändern werden», sagt Grunder. Bei Garnelen und Shrimps
              sei es damals, vor rund 60 Jahren, auch mal so gewesen und heute
              seien diese Produkte überall erhältlich, beliebt und völlig
              normal.
            </p>
          </div>
        </div>{' '}
        <div className='ui container'>
          <div className='visual'>
            <RelationQuiz
              colors={['#FFE462', '#202346', '#964800']}
              labels={['Mehlwürmer', 'Rindfleisch']}
              title={
                <>
                  <b>Insekten vs. Rind</b>
                  <br />
                  Was schätzen Sie?
                </>
              }
              subline={
                <>
                  * Die berechneten Werte sind Durchschnittswerte und können je
                  nach Ausgangslage und Produktionsbedingungen variieren.
                  <br />{' '}
                  <span>
                    Quelle: Fleisch der Zukunft/ Trendanalyse 2020/
                    Umweltbundesamt, Berlin
                  </span>
                </>
              }
              questions={[
                {
                  q: (
                    <>
                      Wie gross ist das <b>Verhältnis der Landflächen*</b>,
                      welche für die Produktion von 1 kg Mehlwürmer und 1 kg
                      Rindfleisch benötigt werden?
                    </>
                  ),
                  max: 93.25,
                  rel: [1, 60.5],
                  start: 93.25 / 2,
                  a: [1.52, 92],
                  unit: (
                    <>
                      m<sup>2</sup>
                    </>
                  )
                },
                {
                  q: (
                    <>
                      Wie gross ist das{' '}
                      <b>
                        Verhältnis der emittierten Treibhausgase* in CO
                        <sub>2</sub>-Äquivalenten
                      </b>{' '}
                      bei der Produktion von 1 kg Mehlwürmer und 1 kg
                      Rindfleisch?
                    </>
                  ),
                  max: 32.7,
                  rel: [1, 25.4],
                  start: 32.7 / 2,
                  a: [1.2, 30.5],
                  unit: (
                    <>
                      kg CO<sub>2</sub>
                    </>
                  )
                },
                {
                  q: (
                    <>
                      Wie gross ist das{' '}
                      <b>Verhältnis von verbrauchtem Wasser*</b> für die
                      Produktion von 1 kg Mehlwürmer und 1 kg Rindfleisch?
                    </>
                  ),
                  max: 19756,
                  rel: [1, 3.6],
                  start: 19756 / 2,
                  a: [4341, 15415],
                  unit: <>l</>
                }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
